export default __webpack_public_path__ + "static/media/tni-division.3795fbfa.jpg";